

import { useReducer, useEffect } from "react"
import { Box } from "@mui/material"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import lockedReducer from "../../../lib/reducer"
import { emitSnackbar } from "../../../lib/snackbar-emitter"
import api, { getEnterpriseId } from "../../../lib/api"
import QRCode from "react-qr-code";
import { loader } from "../../../lib/loader"

let pollingId = 0


const getQR = async (account, setState) => {
    const enterpriseId = getEnterpriseId()
    loader.on()
    const res = await api.get(
        `/enterprises/${enterpriseId}/scout_accounts/${account.id}/getqr/`,
        { timeout: 30000 }
    );
    if (res.status === 200) {
        setState({ qrcode: res.data.code });
    } else {
        emitSnackbar({ message: 'Erro ao gerar o código QR.', severity: 'error' })
    }
    loader.off()
};

const checkConnection = async (account, handleClose, handleSuccess) => {
    const enterpriseId = getEnterpriseId()
    const res = await api.get(
        `/enterprises/${enterpriseId}/scout_accounts/${account.id}/checkconnection/`
    )
    if (res.status === 200) {
        if (res.data.state === "open") {
            emitSnackbar({ message: 'Número conectado com sucesso!', severity: 'success' })
            handleClose()
            handleSuccess();
        } else if (res.data.state === "wrongNumber") {
            emitSnackbar({ message: 'Número incorreto.', severity: 'error' })
            handleClose();
        }
    } else {
        console.error("Error checking connection", res);
        emitSnackbar({ message: 'Conta não encontrada.', severity: 'error' })
        handleClose();
    }
};

const ConnectPhone = ({ account, handleClose, handleSuccess }) => {

    const [state, setState] = useReducer(lockedReducer, {
        qrcode: ''
    })

    useEffect(() => {
        getQR(account, setState);
        clearInterval(pollingId);
        pollingId = setInterval(async () => {
            await checkConnection(account, handleClose, handleSuccess);
        }, 5 * 1000);

        return () => {
            // Cleanup on component unmount
            clearInterval(pollingId);
        };
    }, [account, handleClose, handleSuccess]);

    return (
        <DefaultModal
            title={
                'Conectar telefone'
            }
            handleClose={handleClose}
            maxWidth="sm"
        >
            <Box display='flex' gap='1rem' justifyContent='center'>
                <Box>
                    <div className="max-w-sm p-4 bg-white text-gray-900">
                        <p className="text-xs text-gray-600 mb-3">
                            Para conectar um telefone, siga os passos abaixo:
                        </p>
                        <ol className="space-y-2 list-none p-0 m-0">
                            {[
                                <>No celular a ser monitorado, abra o <strong>WhatsApp</strong></>,
                                <>Vá em <strong>"Menu"</strong> ou <strong>"Configurações"</strong></>,
                                <>Escolha <strong>"Dispositivos conectados"</strong></>,
                                <>Clique em <strong>"Conectar dispositivo"</strong></>,
                                <>Escaneie o código QR ao lado</>,
                            ].map((step, i) => (
                                <li key={i} className="flex gap-3 text-xs text-gray-800">
                                    <span className="font-bold text-gray-900 min-w-[20px]">{i + 1}.</span>
                                    <span>{step}</span>
                                </li>
                            ))}
                        </ol>
                    </div>
                </Box>
                {state.qrcode &&
                    <Box className='bg-gray-100 rounded-xl p-4 text-center' sx={{ background: '#ebf4f6', display: 'flex', alignItems: 'center' }}>
                        <QRCode size='150' value={state.qrcode} />
                    </Box>}
            </Box>
        </DefaultModal>
    )
}

export default ConnectPhone